import { render } from "./WorkbookCard.vue?vue&type=template&id=2cc25264"
import script from "./WorkbookCard.vue?vue&type=script&lang=js"
export * from "./WorkbookCard.vue?vue&type=script&lang=js"

import "./WorkbookCard.vue?vue&type=style&index=0&id=2cc25264&lang=css"
script.render = render

export default script